import apiService from '../apiService';
import apiSpinnerService from '../apiSpinnerService';

import svcConfig from './knowConfig';

const knowService = {
  getKnowData: (request) => {
    return apiService('getKnowData', svcConfig, request);
  },
  getKnowResult: (request) => {
    return apiService('getKnowResult', svcConfig, request);
  },
  saveKnowData: (request) => {
    return apiService('saveKnowData', svcConfig, request);
  },
  getKnowScores: (request) => {
    return apiService('getKnowScores', svcConfig, request);
  },
  updateKnowData: (request) => {
    return apiService('updateKnowData', svcConfig, request);
  },
  getKnowDataSpinner: (request) => {
    return apiSpinnerService('getKnowData', svcConfig, request);
  },
  getKnowResultSpinner: (request) => {
    return apiSpinnerService('getKnowResult', svcConfig, request);
  },
  saveKnowDataSpinner: (request) => {
    return apiSpinnerService('saveKnowData', svcConfig, request);
  },
  getKnowScoresSpinner: (request) => {
    return apiSpinnerService('getKnowScores', svcConfig, request);
  },
  updateKnowDataSpinner: (request) => {
    return apiSpinnerService('updateKnowData', svcConfig, request);
  },
  uploadCertificateFile: (request) => {
    return apiService('uploadCertificateFile', svcConfig, request);
  },
  downloadFile: (request) => {
    return apiService('downloadFile', svcConfig, request);
  },
};

export default knowService;
